import React, { useState } from "react";
import { Alert, Button, Modal } from "antd";
import { useNavigate } from "react-router-dom";

const QuotNumberErrorModal = ({
  isModalOpen,
  setIsModalOpen,
  data,
  newNumber,
  setFormData,
  shouldRefresh = false,
}) => {
  const navigate = useNavigate();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
    setFormData((prevState) => ({
      ...prevState,
      quoteNumber: newNumber,
    }));
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    if (shouldRefresh) {
      // Refresh the page (similar to reloading the page)
      window.location.reload();
    } else {
      // Navigate back to the previous page
      navigate(-1);
    }
  };

  return (
    <>
      <Modal
        title="Warning"
        open={isModalOpen}
        onOk={handleOk}
        okText="Yes"
        cancelText="No"
        onCancel={handleCancel}
      >
        <Alert
          type="error"
          message={`Quotation Number ${data?.quoteNumber} already exists. Do you want to proceed with new ${newNumber} ?`}
        />
      </Modal>
    </>
  );
};

export default QuotNumberErrorModal;